<template>
	<div class="user-action-initiated">
		<speaker-notes :notes="notes"></speaker-notes>
		<h2>Initialize on User Action</h2>
		<p class="subtitle">Browsers do not allow auto-playing sound!</p>
		<div class="flex">
			<div>
				<img class="play wide" src="@/assets/images/play-button-arrow.png" alt="play button"/>
				<img class="play narrow" src="@/assets/images/play-button-no-arrow.png" alt="play button"/>
				<img class="arrow narrow" src="@/assets/images/arrow-down.png" alt="arrow to handler code"/>
			</div>
			<code class="p1">
				<div>onDoStuffHandler(ev) {</div>
				<span class="indent1">this.ac = new AudioContext();</span>
				<span class="indent1">this.ac.<span class="b1">resume()</span>.then(() => {</span>
				<span class="indent2">// Now it is safe to use.</span>
				<span class="indent2">store.dispatch("startPlay");</span>
				<span class="indent1">});</span>
				<div>}</div>
			</code>
		</div>
		<div class="narrow">
			<img class="arrow" src="@/assets/images/arrow-down.png" alt="arrow to watch code"/>
		</div>
		<div class="flex">
			<code>
				<div>watch:</div>
				<span class="indent1">startPlay() {</span>
				<span class="indent2">// Still safe to use.</span>
				<span class="indent2">doAudioStuff(this.ac);</span>
				<span class="indent1">}</span>
			</code>
			<div class="wide">
				<img class="arrow" src="@/assets/images/arrow-back.png" alt="arrow to watch code"/>
			</div>
		</div>
	</div>
</template>

<script>
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "user-action-initiated",
		components: {SpeakerNotes},
		data() {
			return {
				notes: [
					"To fight against websites that would auto-play ads,",
					"Browsers require the AudioContext be acquired in the handler of a user click.",
					"Not how frameworks work.",
					"AC must be created directly in the click handler.",
					"Otherwise it is suspended.",
					"Make sure to resume when you are going to use it.",
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.user-action-initiated {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.flex {
		display: flex;
		flex-direction: column;
	}
	@media screen and (min-width: 490px) {
		.flex {
			flex-direction: row;
		}
	}
	.play.wide {
		margin-right: 30px;
	}
	code {
		margin-top: 90px;
	}
	.arrow {
		margin-left: 40px;
		margin-top: 10px;
	}
	.subtitle {
		margin-top: -35px;
	}
	.wide {
		display: none;
	}
	@media screen and (min-width: 490px) {
		.narrow {
			display: none;
		}
		.wide {
			display: block;
		}
	}
</style>
